import PropTypes from 'prop-types';
// @mui
import { Card, Stack, Typography, Divider } from '@mui/material';
// utils
import { fNumber } from '../../../../../utils/formatNumber';

// ----------------------------------------------------------------------

ProfileFollowInfo.propTypes = {
  follower: PropTypes.number,
  following: PropTypes.number,
};

export default function ProfileFollowInfo({ follower, following }) {
  return (
    <Card sx={{ py: 3 }}>
      <Stack direction="row" divider={<Divider orientation="vertical" flexItem />}>
        <Stack width={1} textAlign="center">
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Total Deposit
          </Typography>
          <Typography variant="h4">{fNumber(follower)}</Typography>
        </Stack>

        <Stack width={1} textAlign="center">
          <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
            Joined since
          </Typography>
          <Typography variant="h6">{following ? new Date(following).toLocaleDateString('id-ID', { 
            day: '2-digit', 
            month: 'long', 
            year: 'numeric' 
          }) : 'N/A'}</Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
